import { Box, Text, Button } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import BottomTabHome from '../../assets/icons/BottomTabHome';
import BottomTabPractice from '../../assets/icons/BottomTabPractice';
import BottomTabCreate from '../../assets/icons/BottomTabCreate';
import BottomTabApply from '../../assets/icons/BottomtabApply';
import { Link as RouterLink } from 'react-router-dom';
import { usePublishedItems } from '../../../hooks/V2/useCourse';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';
import { useAssessmentSubmission } from '../../../hooks/V2/useAssessmentSumbission';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { sendTrackingEvent } from '../../../utils/gtm';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

export let navLinkData = [
	{
		url: '/',
		tabName: 'Home',
		icon: <BottomTabHome boxSize={'24px'} />,
		active: () => window.location.pathname === '/',
		isDisabled: false,
	},
	{
		url: `/dashboard/published-item/`,
		tabName: 'Practice',
		icon: <BottomTabPractice boxSize={'24px'} />,
		active: () => window.location.pathname.includes('/dashboard'),
		isDisabled: false,
	},
	{
		url: '/resume',
		tabName: 'Resume',
		icon: <BottomTabCreate boxSize={'24px'} />,
		active: () => window.location.pathname.includes('/resume'),
		isDisabled: false,
	},
	{
		url: '/apply',
		tabName: 'Apply',
		icon: <BottomTabApply boxSize={'24px'} />,
		active: () => window.location.pathname.includes('/apply'),
		isDisabled: false,
	},
];

const LeftNav = () => {
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const { selectedCourse } = useSelectedCourse();
	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(selectedCourse?.value);
	const [roadmapPublishedItem, setRoadmapPublishedItem] = React.useState<any>();
	const [assessmentPublishedItem, setAssessmentPublishedItem] = React.useState<any>();
	const { isKnowYourLevelAssessmentGiven, setIsKnowYourLevelAssessmentGiven } = useAssessmentToken();
	React.useEffect(() => {
		if (selectedCourse) {
			refetchPublishedItems();
		}
	}, [selectedCourse.value, refetchPublishedItems, selectedCourse]);

	const {
		data: userAssessment,
		status,
		refetch: refetchUserAssessment,
		isLoading: loadingUserAssessment,
	} = useAssessmentSubmission(assessmentPublishedItem?._id || '');

	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const assessment = publishedItems.find(item => item.entityType === 'Assessment');
		// @ts-ignore
		setAssessmentPublishedItem(assessment);
		console.log('assessment----', assessment);
	}, [publishedItems]);

	useEffect(() => {
		if (!assessmentPublishedItem) return;
		refetchUserAssessment();
	}, [assessmentPublishedItem?._id, refetchUserAssessment]);

	useEffect(() => {
		// if know you level user assessment is given then set the context
		if (userAssessment?.assessmentStatus === 'COMPLETED' || userAssessment?.assessmentStatus === 'GRADED') {
			setIsKnowYourLevelAssessmentGiven(true);
		} else {
			setIsKnowYourLevelAssessmentGiven(false);
		}
	}, [setIsKnowYourLevelAssessmentGiven, userAssessment, userAssessment?.assessmentStatus]);

	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const roadmap = publishedItems.find(item => item.entityType === 'Roadmap');
		// @ts-ignore
		setRoadmapPublishedItem(roadmap);
		console.log('roadmap', roadmap);
	}, [publishedItems]);

	useEffect(() => {
		navLinkData = [
			{
				url: '/dashboard',
				tabName: 'Home',
				icon: <BottomTabHome boxSize={'24px'} />,
				active: () => window.location.pathname === '/dashboard',
				isDisabled: false,
			},
			{
				url: roadmapPublishedItem ? `/dashboard/published-item/${roadmapPublishedItem?._id}` : `#`,
				tabName: domainConfig?.key !== SAGEX_ORG_KEY ? 'Practice' : 'Modules',
				icon: <BottomTabPractice boxSize={'24px'} />,
				active: () => window.location.pathname.includes('/published-item') && !window.location.pathname.includes('/syllabus'),
				isDisabled: false,
			},
		];
		if (SAGEX_ORG_KEY !== domainConfig?.key) {
			navLinkData.push({
				url: '/resume',
				tabName: 'Resume',
				icon: <BottomTabCreate boxSize={'24px'} />,
				active: () => window.location.pathname.includes('/resume'),
				isDisabled: !isKnowYourLevelAssessmentGiven,
			});
			navLinkData.push({
				url: '/apply',
				tabName: 'Apply',
				icon: <BottomTabApply boxSize={'24px'} />,
				active: () => window.location.pathname.includes('/apply'),
				isDisabled: !isKnowYourLevelAssessmentGiven,
			});
		}
	}, [selectedCourse, roadmapPublishedItem, navLinkData]);

	return (
		<Box display={{ base: 'none', lg: 'block' }} minW="260px" borderRight="1px solid #D9D9D9" pt="32px">
			{navLinkData.map(({ isDisabled, tabName, icon, active, url }, index) => {
				return (
					<Box
						as={RouterLink}
						to={url}
						py="16px"
						pl="24px"
						gap="8px"
						h="56px"
						key={index}
						w="full"
						display={'flex'}
						alignItems="center"
						flexDirection={'row'}
						justifyContent={'start'}
						bg={active() ? '#F2F6FF' : 'white'}
						color={active() ? '#4358F6' : '#0A0103'}
						boxShadow={active() ? '4px 0px 0px 0px #3470E4 inset' : 'none'}
						onClick={() => {
							if (tabName == 'Home') {
								sendTrackingEvent({
									event: 'cnd_home',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Practice') {
								sendTrackingEvent({
									event: 'cnd_practice',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Resume') {
								sendTrackingEvent({
									event: 'cnd_resume',
									eventLabel: window.location.href,
								});
							} else if (tabName == 'Apply') {
								sendTrackingEvent({
									event: 'cnd_apply',
									eventLabel: window.location.href,
								});
							}
						}}
					>
						<Box boxSize="24px">{icon}</Box>
						<Text mt="2px" textStyle="body1-md">
							{tabName}
						</Text>
					</Box>
				);
			})}
		</Box>
	);
};

export default LeftNav;
